import Component from '../core/Component'
import enquire from 'enquire.js'
import { queries } from '../core/config'
import { disableScrolling, enableScrolling } from '../services/Viewport/scroll'
import { toggleClass } from '../utils/dom'
import EventBus from '../core/EventBus'

import NavCollapse from './NavCollapse'
import NavLayer from './NavLayer'

const ACTIVE = 'is-active'
const SUBNAV_VISIBLE = 'is-subnav-visible'
const ANIMATED = 'is-animated'
const lang = document.querySelector('.Header-language')

export default class Nav extends Component {

    static States = {
        ACTIVE,
        SUBNAV_VISIBLE
    }

    constructor(element) {
        super(element)

        this.ref = {
            items: [],
            links: [],
        }

        this.match = ::this.match
        this.unmatch = ::this.unmatch
        this.toggle = ::this.toggle

        this.shouldRender = false
        this.isDesktop = false

        this.openTimer = null
        this.openTimerDuration = 20
        this.closeTimer = null
        this.closeTimerDuration = 200

        this.enquireHandler = {
            match: this.match,
            unmatch: this.unmatch
        }
    }

    prepare() {
        enquire.register(queries.largeUp, this.enquireHandler)
        EventBus.on('nav:toggle', this.toggle)

        this.navCollapse = new NavCollapse(this.element)
        this.navCollapse.prepare()

        this.navLayer = new NavLayer(document.getElementById('nav-layer'))
        this.navLayer.prepare()
        this.navLayer.onMouseEnter(() => {
            clearTimeout(this.openTimer)
            clearTimeout(this.closeTimer)
        })
        this.navLayer.onHide(() => {
            this.element.classList.remove(SUBNAV_VISIBLE)
        })

        this.navLayer.onMouseLeave(::this.handleItemMouseLeave)

        this.ref.links.forEach(item => {
            item.addEventListener('mouseenter', ::this.handleItemMouseEnter)
            item.addEventListener('mouseleave', ::this.handleItemMouseLeave)
            item.addEventListener('click', ::this.handleClick)
        })
    }

    destroy() {
        enquire.unregister(queries.largeUp, this.enquireHandler)
        EventBus.off('nav:toggle', this.toggle)
        this.navCollapse.destroy()
        this.navLayer.destroy()
    }

    handleClick = event => {
        const blockId = event.target.dataset.navPane
        if (blockId && !this.isDesktop) {
            event.preventDefault()
            this.navLayer.show(blockId)
            this.element.classList.add(SUBNAV_VISIBLE)
        }
    }

    handleItemMouseEnter = event => {
        if (!this.isDesktop) {
            return
        }

        const blockId = event.target.dataset.navPane


        if (blockId) {
            clearTimeout(this.openTimer)
            clearTimeout(this.closeTimer)
            this.openTimer = setTimeout(() => {
                const blockPos = event.target.getBoundingClientRect()
                this.navLayer.show(blockId, blockPos)
                this.ref.links.forEach(element => toggleClass(element, ACTIVE, element === event.target))
            }, this.openTimerDuration)

            //const height = this.blockId.offsetHeight

        }
    }

    handleItemMouseLeave = event => {
        if (!this.isDesktop) {
            return
        }

        this.closeTimer = setTimeout(() => {
            this.navLayer.hide()
            this.ref.links.forEach(element => element.classList.remove(ACTIVE))
        }, this.closeTimerDuration)
    }

    match() {
        this.hide()
        this.isDesktop = true
    }

    unmatch() {
        this.isDesktop = false
    }

    show() {
        disableScrolling()
        this.element.classList.add(ACTIVE)
        lang.classList.add(ACTIVE)

        this.openTimer = setTimeout(() => {
            this.element.classList.add(ANIMATED)
            lang.classList.add(ANIMATED)

        }, this.openTimerDuration)
    }

    hide() {
        enableScrolling()
        this.element.classList.remove(ACTIVE)
        this.element.classList.remove(SUBNAV_VISIBLE)
        lang.classList.remove(ACTIVE)

        this.closeTimer = setTimeout(() => {
            this.element.classList.remove(ANIMATED)
            lang.classList.remove(ANIMATED)

        }, this.openTimerDuration)
    }

    toggle() {
        if (this.is(ACTIVE)) {
            this.hide()
            this.navLayer.hide()
        } else {
            this.show()
        }
    }
}